import { render, staticRenderFns } from "./wind_policy_dialog.vue?vue&type=template&id=8217183e&scoped=true&"
import script from "./wind_policy_dialog.vue?vue&type=script&lang=js&"
export * from "./wind_policy_dialog.vue?vue&type=script&lang=js&"
import style0 from "./wind_policy_dialog.vue?vue&type=style&index=0&id=8217183e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8217183e",
  null
  
)

export default component.exports